import { Card, Checkbox, Chip, Collapse, List, ListItem, ListItemText, Typography } from "@mui/material";
import React, { useState } from "react";
import theme from '../../utils/theme'

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import ApiService from "../../api_service/api_service";
import { Link, useNavigate } from "react-router-dom";

const priceList2 = ['Under 500,000 Ks', 'Above 500,000 Ks']
const priceList = [
    {
        title: "Under 500,000 Ks",
        order: "asc"
    },
    {
        title: "Above 500,000 Ks",
        order: "desc"
    },
]

const ProductFilter = () => {
    const params = new URLSearchParams(window.location.search);
    let brandId = params.get('brand');
    let categoryId = params.get('category');
    let orderBy = params.get('order_by');

    const [ categories, setCategories ] = React.useState([]);
    const [ brands, setBrands ] = React.useState([]);
    const [priceFilters, setPriceFilters] = useState([]);

    React.useEffect(() => {
    const getCategories = async () => {
            let catRes = await ApiService.categories();
            setCategories(catRes.data);
            let brandRes = await ApiService.brands();
            setBrands(brandRes.data);
            if(brandId != null){
                setBrandsOpen(true)
                var selectedBrand = brandRes.data.filter((brand) => brand._id == brandId)[0];
                setFilters([selectedBrand.name])
            }
            if(categoryId != null){
                setCategoriesOpen(true)
                var selectedCategory = catRes.data.filter((category) => category._id == categoryId)[0];
                setCatFilters([selectedCategory.name])
            }
            if(orderBy != null){
                setPriceOpen(true)
                var selectedOrder = priceList.filter((selected) => selected.order == orderBy)
                setPriceFilters(selectedOrder);
            }
    };
    getCategories();
    }, []);

    const handleDelete = (item) => {
        setFilters(filters.filter((selected) => selected !== item));
        const newQueries = {
            ...queries,
            brand: ''
        };
        setQueries(newQueries);
        const query = buildQuery(newQueries);
        console.log(query);
        navigate(`/product-categories?${query}`);
    };
    
    const handleCatDelete = (item) => {
        setCatFilters(catFilters.filter((selected) => selected !== item));
        const newQueries = {
            ...queries,
            category: ''
        };
        setQueries(newQueries);
        const query = buildQuery(newQueries);
        console.log(query);
        navigate(`/product-categories?${query}`);
    };

    const [brandsOpen, setBrandsOpen] = useState(false);
    const [priceOpen, setPriceOpen] = useState(false);
    const [categoriesOpen, setCategoriesOpen] = useState(false);
    const [filters, setFilters] = useState([]);

    const handleBrandsClick = () => {
        setBrandsOpen(!brandsOpen);
    };

    const handlePriceClick = () => {
        setPriceOpen(!priceOpen);
    };

    const handleCategoriesClick = () => {
        setCategoriesOpen(!categoriesOpen);
    };

    const handleFilterClick = (item) => {
        setPriceFilters()
        if (filters.includes(item)) {
            setFilters(filters.filter((selected) => selected !== item));
        }
         else {
            // setFilters([...filters, item]);
            setFilters([item]);
        }
    };

    const [catFilters, setCatFilters] = useState([]);
    const handleCatFilterClick = (item) => {
        if (catFilters.includes(item)) {
            setCatFilters(catFilters.filter((selected) => selected !== item));
        }
         else {
            // setFilters([...filters, item]);
            setCatFilters([item]);
        }
    };

    const navigate = useNavigate();

    
    const handlePriceFilterClick = (item) => {
        console.log(item)
        if (priceFilters.includes(item)) {
            setPriceFilters(priceFilters.filter((selected) => selected !== item));
        }
         else {
            // setFilters([...filters, item]);
            setPriceFilters([item]);
        }
        setFilters([]);
        setCatFilters([]);
        navigate(`/product-categories?order_by=${item.order}`);
    };

    
    const buildQuery = (params) => {
        const query = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
          if (value) query.append(key, value);
        });
        return query.toString();
    };
    const [queries, setQueries] = useState({
        brand: brandId,
        category: categoryId,
    });
    const handleQuery = (value, qname) => {
        if(qname == 'brand'){
            handleFilterClick(value.name)
        }
        if(qname == 'category'){
            handleCatFilterClick(value.name)
        }
        const newQueries = {
            ...queries,
            [qname]: value._id
        };
        setQueries(newQueries);
        const query = buildQuery(newQueries);
        console.log(query);
        setPriceFilters([])
        setPriceOpen(false);
        navigate(`/product-categories?${query}`);
    }

    const getFilterQuery = () => {
        let query = "?filters=";
        for(var i = 0; i < filters.length; i++){
            if(i == filters.length - 1){
                query += filters[i];
            }else{
                query += filters[i] + ",";
            }
        }
    }


    return (
        <Card sx={{
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
        }}>
            <Typography sx={{
                fontSize: theme.palette.SubTitle.fontSize,
                fontWeight: 'W500',
                px: '10px',
                pt: '20px'
            }}>Filters</Typography>
            {
                filters.map((filterItem, index) => (
                    <Chip
                        key={index}
                        label={filterItem}
                        variant="outlined"
                        onDelete={() => handleDelete(filterItem)}
                        color='primary'
                        sx={{
                            m: '5px',
                        }}
                    />
                ))
            }
            {
                catFilters.map((filterItem, index) => (
                    <Chip
                        key={index}
                        label={filterItem}
                        variant="outlined"
                        onDelete={() => handleCatDelete(filterItem)}
                        color='primary'
                        sx={{
                            m: '5px',
                        }}
                    />
                ))
            }
            <ListItem button onClick={handleBrandsClick}>
                <ListItemText primary='Brand' />
                {brandsOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </ListItem>
            <Collapse in={brandsOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {brands.map((brand) => (
                        <ListItem key={brand.name} onClick={() => handleQuery(brand, "brand")}>
                            <Checkbox checked={filters.includes(brand.name)} />
                            <ListItemText primary={brand.name} />
                        </ListItem>
                    ))}
                </List>
            </Collapse>    
            <ListItem button onClick={handleCategoriesClick}>
                <ListItemText primary='Category' />
                {categoriesOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </ListItem>
            <Collapse in={categoriesOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {categories.map((category) => (
                        <ListItem key={category._id} onClick={() => handleQuery(category, "category")}>
                            <Checkbox checked={catFilters.includes(category.name)}/>
                            <ListItemText primary={category.name} />
                        </ListItem>
                    ))}
                </List>
            </Collapse>
            <ListItem button onClick={handlePriceClick}>
                <ListItemText primary='Price' />
                {priceOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </ListItem>
            <Collapse in={priceOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {priceList.map((price) => (
                        <ListItem key={price.title} button onClick={() => handlePriceFilterClick(price)}>
                            <Checkbox checked={priceFilters.includes(price)} />
                            <ListItemText primary={price.title} />
                        </ListItem>
                    ))}
                </List>
            </Collapse>
        </Card>
    )
}

export default ProductFilter
